import {
  InventoryTransactionType,
  ProductInboundTransactionDoc,
  ProductOutboundTransactionDoc,
} from '@gooduncles/gu-app-schema';
import { getProductInboundTransaction, getProductOutboundTransaction } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const getTransaction = (
  transactionType: InventoryTransactionType,
  transactionId: string
): Promise<ProductInboundTransactionDoc | ProductOutboundTransactionDoc | undefined> => {
  if (transactionType === InventoryTransactionType.INBOUND) {
    return getProductInboundTransaction(transactionId);
  }
  return getProductOutboundTransaction(transactionId);
};

const useSWRTransaction = (
  transaction:
    | {
        transactionType: InventoryTransactionType;
        transactionId: string;
      }
    | undefined
) => {
  const { data, isLoading, error } = useSWRImmutable(
    transaction ? `${transaction.transactionType}-${transaction.transactionId}` : null,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    () => getTransaction(transaction!.transactionType, transaction!.transactionId)
  );
  return { data, isLoading, error };
};

export default useSWRTransaction;
